import { Routes } from "@angular/router";
import { HomeComponent } from "./home/home.component";

import { FullComponent } from "./layouts/full/full.component";
import { AuthService } from "./core/guards/auth.guard";
import { ProfileGuard } from "./core/guards/profile.guard";
import { PageNotFoundComponent } from "./home/home-components/page-not-found/page-not-found.component";
import { EvaluatorOutletComponent } from "./evaluator-dashboard/components/evaluator-outlet/evaluator-outlet.component";

export const AppRoutes: Routes = [
  {
    path: "",
    component: HomeComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./home/home-routing.module").then((m) => m.HomeRoutingModule),
      },
    ],
  },
  {
    path: "user",
    component: FullComponent,
    canActivate: [AuthService],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./dashboard/dashboard.module").then((m) => m.DashboardModule),
      },
    ],
  },
  {
    path: "evaluator",
    component: EvaluatorOutletComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./evaluator-dashboard/evaluator-dashboard.module").then(
            (m) => m.EvaluatorDashboardModule
          ),
      },
    ],
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];
